import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  fetchUser,
  updateUser
} from '../../actions/profile/apiRequests';
import { notifyInfo } from '../../utils/notifier';
import { isSpruceAdmin } from '../../utils/roles';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import withEulaRestrictions from '../license/withEulaRestrictions';
import Page from '../shared/Page';
import Loader from '../shared/Loader';
import ProfilePage from './ProfilePage';
import { ADMINS } from '../../constants/userRoles';


export class EditUserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: null,
      notFound: false
    };
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    const {
      match={},
      location={}
    } = this.props;
    const { state:locationState={} } = location;

    fetchUser(match.params.id)
      .then(profile => this.setState({ profile }))
      .then(() => {
        if (locationState.created) {
          notifyInfo('User was created');
        }
      })
      .catch(({ status }) => {
        if (status === 404 || status === 403) {
          this.setState({ notFound: true });
        }
      })
  }

  onSave(user) {
    const { profile } = this.state;

    return updateUser(profile.id, user)
    .then(() => {
      this.setState({
        profile: {
          ...this.state.profile,
          ...user
        }
      })
    });
  }

  onCancel() {
    this.props.history.goBack();
  }

  render() {
    const {
      title,
      currentUserId
    } = this.props;
    const {
      profile,
      notFound
    } = this.state;

    return (
      <Choose>
        <When condition={notFound}>
          <Page header={title}>
            <div className='text-center'>
              <p className='m-5'>User was not found or access denied</p>
            </div>
          </Page>
        </When>
        <When condition={!profile}>
          <Page header={title}>
            <Loader />
          </Page>
        </When>
        <When condition={profile.id === currentUserId}>
          <Redirect to={`/profile`} />
        </When>
        <Otherwise>
          <ProfilePage
            profile={profile}
            editLoginInfo={true}
            editUom={false}
            editSignature={false}
            passwordRequired={false}
            editRole={true}
            editCompany={false}
            editStatus={true}
            editEmail={true}
            companyUser={true}
            onSave={this.onSave}
            onCancel={this.onCancel}
            hasActiveCompanyAdmin={true}
            {...this.props}
          />
        </Otherwise>
      </Choose>
    );
  }
}

EditUserPage.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
  location: PropTypes.object,
  title: PropTypes.string,
  currentUserId: PropTypes.string
};

const mapStateToProps = ({ profile }) => ({
  currentUserId: profile.id
});

export default connect(mapStateToProps)(
  withEulaRestrictions(withRoleRestrictions(EditUserPage, ADMINS))
);



// WEBPACK FOOTER //
// src/components/profile/EditUserPage.jsx